import { call, put, takeLatest } from 'redux-saga/effects';

import authService from 'services/authService';

import { fetchProfile } from 'store/session/actions';

import { types, twoFactorAuthSecret, verifyToken } from './actions';

function* watchRequestSecret(action) {
  try {
    const { id } = action.payload;
    const response = yield call(authService.requestTwoFactorAuthSecret, id);
    yield put(twoFactorAuthSecret.success(response));
  } catch (error) {
    yield put(twoFactorAuthSecret.error(error));
  }
}

function* watchVerifyToken(action) {
  try {
    const { id, token, secret } = action.payload;
    const response = yield call(
      authService.verifyTwoFactorAuthToken,
      id,
      token,
      secret,
    );
    if (response.isValid == true) {
      yield put(fetchProfile.request());
      yield put(verifyToken.success());
    } else yield put(verifyToken.error(new Error('Invalid token')));
  } catch (error) {
    yield put(verifyToken.error(error));
  }
}

export default function* root() {
  yield takeLatest(types.TWO_FACTOR_AUTH_SECRET_REQUEST, watchRequestSecret);
  yield takeLatest(
    types.TWO_FACTOR_AUTH_VERIFY_TOKEN_REQUEST,
    watchVerifyToken,
  );
}
